module.exports = __webpack_public_path__ + "static/media/inviteBackground.1e83d085.png";